module.exports = __webpack_public_path__ + "736b3fd6afd2e107cc3db1961ab60890.svg";